import { generatePath, matchPath } from "react-router-dom";
import breadcrumbRoutes from "./breadcrumbRoutes";

// HO-TASK-250: convierte la URL actual en la lista de migas de pan.
//
// Recorre la ruta prefijo a prefijo (/dashboard, /dashboard/finance,
// /dashboard/finance/12, ...) y por cada uno busca la primera entrada de
// breadcrumbRoutes que coincida exactamente. Los prefijos sin entrada, o con
// `label: null`, no generan nivel: así los ids sueltos y los segmentos
// intermedios ("edit", "my", "create/12") no ensucian la ruta.
//
// Devuelve [{ key, label, to }] en orden, siendo el último la pantalla actual.
export const resolveBreadcrumbs = (pathname, context = {}) => {
  const segments = pathname.split("/").filter(Boolean);
  const crumbs = [];

  segments.forEach((_, index) => {
    const prefix = `/${segments.slice(0, index + 1).join("/")}`;
    let match = null;

    const entry = breadcrumbRoutes.find((route) => {
      match = matchPath(prefix, { path: route.path, exact: true });
      return !!match;
    });

    if (!entry || entry.label === null) return;

    const label =
      typeof entry.label === "function"
        ? entry.label({ ...context, params: match.params })
        : entry.label;

    if (!label) return;

    // Dos niveles seguidos con el mismo nombre no aportan nada: nos quedamos
    // con el más profundo, que es el que refleja la URL actual.
    const previous = crumbs[crumbs.length - 1];
    if (previous && previous.label === label) {
      crumbs.pop();
    }

    const toPattern =
      typeof entry.to === "function"
        ? entry.to({ ...context, params: match.params })
        : entry.to;

    // Niveles que no están en la URL pero sí en el recorrido real (ej. el
    // detalle de un efecto al que se llegó desde los efectos de una
    // propiedad): la entrada los declara en `parents` y van justo antes.
    const parents =
      typeof entry.parents === "function"
        ? entry.parents({ ...context, params: match.params }) || []
        : [];
    parents.forEach((parent, position) => {
      if (!parent?.label || !parent?.to) return;
      const to = generatePath(parent.to, match.params);
      crumbs.push({ key: `${prefix}#parent-${position}`, label: parent.label, to });
    });

    crumbs.push({
      key: prefix,
      label,
      to: toPattern ? generatePath(toPattern, match.params) : prefix,
    });
  });

  return crumbs;
};

export default resolveBreadcrumbs;
